module.exports = __webpack_public_path__ + "static/media/alfa_1.e015be1c.mp4";